/**
 * TanStack Query hooks for `igaming-configurable-dashboards-per-operator-partn`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingConfigurableDashboardsPerOperatorPartnQueryKeys,
	type CreateIgamingConfigurableDashboardsPerOperatorPartnBody,
	type ListIgamingConfigurableDashboardsPerOperatorPartnResponse,
	type IgamingConfigurableDashboardsPerOperatorPartnRow,
} from "./api";

export function useIgamingConfigurableDashboardsPerOperatorPartnList(): UseQueryResult<ListIgamingConfigurableDashboardsPerOperatorPartnResponse, Error> {
	return useQuery({
		queryKey: igamingConfigurableDashboardsPerOperatorPartnQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingConfigurableDashboardsPerOperatorPartnCreate(): UseMutationResult<IgamingConfigurableDashboardsPerOperatorPartnRow, Error, CreateIgamingConfigurableDashboardsPerOperatorPartnBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingConfigurableDashboardsPerOperatorPartnQueryKeys.all });
		},
	});
}

export function useIgamingConfigurableDashboardsPerOperatorPartnDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingConfigurableDashboardsPerOperatorPartnQueryKeys.all });
		},
	});
}
